import React from "react";
import Room from "./Room";
import styled from "styled-components";

const RoomLists = styled.section`
  padding: 5rem 0;
`;
const RoomListsCenter = styled.div`
  width: 80vw;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  grid-row-gap: 2rem;
  grid-column-gap: 30px;
  @media screen and (min-width: 776px) {
    width: 90vw;
  }
  @media screen and (min-width: 992px) {
    width: 95vw;
    max-width: 1170px;
  }
`;

export default function RoomsList({ rooms }) {
  if (rooms.length === 0) {
    return (
      <div className="empty-search">
        <h3>Unfortunately no rooms matched your search results.</h3>
      </div>
    );
  }
  return (
    <RoomLists>
      <RoomListsCenter>
        {rooms.map((item) => {
          return <Room key={item.id} room={item} />;
        })}
      </RoomListsCenter>
    </RoomLists>
  );
}
